"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperatorEscalationUrl = function (cardId, answers, selectionPath, karakuriWebRootUrl, operatorEscalationKeyword, session) {
    var parameters = selectionPath
        .filter(function (x) { return x !== cardId; })
        .map(function (x) {
        var selected = answers
            .filter(function (answer) { return !!answer.actions && answer.actions.actions.some(function (action) { return action.id === x; }); })
            .map(function (_) { return _.actions; })[0];
        if (!selected) {
            return null;
        }
        return {
            action: selected.actions.filter(function (action) { return action.id === x; }).map(function (action) { return action.actionId; })[0],
            answer: selected.id,
            card: cardId,
            displayText: selected.actions.filter(function (action) { return action.id === x; }).map(function (action) { return action.label; })[0]
        };
    })
        .filter(function (x) { return !!x; });
    parameters = __spreadArrays(answers.filter(function (x) { return x.id === cardId; }).map(function (x) { return x.ask; }), parameters, [operatorEscalationKeyword]);
    return karakuriWebRootUrl + "/embed/?queries=" + encodeURIComponent(JSON.stringify(parameters)) + (session.value ? "&session=" + encodeURIComponent(session.value) : '');
};
//# sourceMappingURL=getOperatorEscalationUrl.js.map